import _toConsumableArray from "E:/workspace/ysorder/order_admin_client/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _regeneratorValues from "E:/workspace/ysorder/order_admin_client/node_modules/@babel/runtime/helpers/esm/regeneratorValues.js";
import _regenerator from "E:/workspace/ysorder/order_admin_client/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "E:/workspace/ysorder/order_admin_client/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _createForOfIteratorHelper from "E:/workspace/ysorder/order_admin_client/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/web.dom-collections.iterator.js";
import Cookie from 'js-cookie';
import FooterToolBar from '@/components/tool/FooterToolBar';
import { addserchKeyword, serchKeywordDetail } from '@/services/marketing/searchKeyword';
import importfailed from '@/components/importfailed/index';
import selectProduct from "@/components/commonAdd/selectGroupGoods.vue";
export default {
  name: 'basicSearchKeyword',
  i18n: require('./i18n-searchKeyword'),
  components: {
    selectProduct: selectProduct,
    FooterToolBar: FooterToolBar,
    importfailed: importfailed
  },
  props: {},
  data: function data() {
    return {
      importVisible: false,
      selectedRowKeys: [],
      defaultLangObj: JSON.parse(localStorage.defaultLangObj),
      rightCurrencySymbol: localStorage.rightCurrencySymbol,
      leftCurrencySymbol: localStorage.leftCurrencySymbol,
      newheaders: {
        headers: ''
      },
      //选中的商品list
      selectProductList: [],
      //删除的商品ids
      deleteProductIds: [],
      selectNumber: 0,
      listTotal: 0,
      productList: [],
      isTableLoading: false,
      action: process.env.VUE_APP_API_BASE_URL + "/activity/importGoods/",
      updateLoading: false,
      listLoading: false,
      searchKeywords: [],
      keywordObj: {
        keywordLangList: []
      },
      importObj: {},
      editId: undefined,
      updateData: {
        fromtype: 1
      }
    };
  },
  watch: {
    'selectProductList': function selectProductList() {
      this.selectNumber = this.selectProductList.length;
    }
  },
  activated: function activated() {
    this.newheaders = {
      "x-auth-token": Cookie.get("x-auth-token")
    };
  },
  created: function created() {
    this.newheaders = {
      "x-auth-token": Cookie.get("x-auth-token")
    };
    this.getInitialValue();
  },
  computed: {
    columns: function columns() {
      var columns = [{
        title: this.$t('publicuse.goodsno'),
        dataIndex: 'goodsNo',
        key: 'goodsNo',
        width: '15%'
      }, {
        dataIndex: 'goodsName',
        key: 'goodsName',
        width: '40%',
        slots: {
          title: 'goodsnametitle' //自定义标头
        },
        ellipsis: true
      }, {
        title: this.$t('public.status'),
        dataIndex: 'productStatus',
        key: 'productStatus',
        width: '10%',
        scopedSlots: {
          customRender: 'productStatus' //自定义表格里面的内容
        }
      },
      // {
      //     title: this.$t('public.sellPrice'),
      //     dataIndex: 'price',
      //     key: 'price',
      //     width: '10%',
      //     scopedSlots: {
      //         customRender: 'sellPrice',
      //     },
      //     align: 'right'
      // }, 
      {
        title: this.$t('publicuse.stock'),
        dataIndex: 'productStockNum',
        key: 'productStockNum',
        width: '10%',
        align: 'right'
      }, {
        title: this.$t('publicuse.action'),
        dataIndex: 'action',
        key: 'action',
        width: '15%',
        scopedSlots: {
          customRender: 'action'
        },
        align: 'center'
      }];
      return columns;
    },
    alreadySelect: function alreadySelect() {
      if (_.isArray(this.productList) && this.productList.length > 0) {
        return this.productList.map(function (item) {
          return item.productSpecId;
        });
      } else {
        return [];
      }
    }
  },
  mounted: function mounted() {
    this.editId = Number(this.$route.query.id);
    if (this.editId > 0) {
      this.getList(this.editId);
    }
  },
  methods: {
    confirmProduct: function confirmProduct(data) {
      if (_.isArray(data) && data.length > 0) {
        this.productList = data.map(function (item) {
          return {
            lastUpdateTime: null,
            goodsName: item.productName,
            goodsNo: item.productNo,
            productOptionName: item.specValueName,
            // price: item.price,
            productStatus: item.productStatus,
            productStockNum: item.productStocknum,
            productSpecId: item.optionId
          };
        });
      } else {
        this.productList = [];
      }
      this.listTotal = this.productList.length;
    },
    addProduct: function addProduct() {
      var _this = this;
      this.$nextTick(function () {
        _this.$refs.selectModal.visible = true;
      });
    },
    getInitialValue: function getInitialValue() {
      var self = this;
      self.defaultLangObj = JSON.parse(localStorage.getItem('defaultLangObj'));
      self.langList = JSON.parse(localStorage.getItem('langList'));
      self.keywordObj.keywordLangList = [];
      var _iterator = _createForOfIteratorHelper(self.langList),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var item = _step.value;
          var nameObj = {};
          //因为编辑的是否需要id
          nameObj.id = '';
          nameObj.titleName = self.$t('serchKeyword.font') + '(' + item.langName + ')';
          //多语言id
          nameObj.langId = item.langId;
          //活动名称
          nameObj.name = "";
          if (item.langId == self.defaultLangObj.langId) {
            nameObj.required = true;
          } else {
            nameObj.required = false;
          }
          self.keywordObj.keywordLangList.push(nameObj);
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    },
    getList: function getList(id) {
      var _this2 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var res, productData, dataList, _iterator2, _step2, _loop, _t;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              _this2.listLoading = true;
              _context2.n = 1;
              return serchKeywordDetail(id);
            case 1:
              res = _context2.v;
              _context2.p = 2;
              if (!(res.data.code == 200)) {
                _context2.n = 10;
                break;
              }
              _this2.productList = [];
              productData = res.data.data;
              dataList = productData.searchKeywords;
              _iterator2 = _createForOfIteratorHelper(_this2.keywordObj.keywordLangList);
              _context2.p = 3;
              _loop = /*#__PURE__*/_regenerator().m(function _loop() {
                var langObj, findObj;
                return _regenerator().w(function (_context) {
                  while (1) switch (_context.n) {
                    case 0:
                      langObj = _step2.value;
                      findObj = _.find(dataList, function (o) {
                        return o.langId == langObj.langId;
                      });
                      if (findObj) {
                        langObj.id = findObj.id;
                        langObj.name = findObj.name;
                      }
                    case 1:
                      return _context.a(2);
                  }
                }, _loop);
              });
              _iterator2.s();
            case 4:
              if ((_step2 = _iterator2.n()).done) {
                _context2.n = 6;
                break;
              }
              return _context2.d(_regeneratorValues(_loop()), 5);
            case 5:
              _context2.n = 4;
              break;
            case 6:
              _context2.n = 8;
              break;
            case 7:
              _context2.p = 7;
              _t = _context2.v;
              _iterator2.e(_t);
            case 8:
              _context2.p = 8;
              _iterator2.f();
              return _context2.f(8);
            case 9:
              _this2.listTotal = productData.productTotalNum;
              _this2.productList = productData.productList;
            case 10:
              _context2.p = 10;
              _this2.listLoading = false;
              return _context2.f(10);
            case 11:
              return _context2.a(2);
          }
        }, _callee, null, [[3, 7, 8, 9], [2,, 10, 11]]);
      }))();
    },
    onChange: function onChange(selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys;
    },
    onSelect: function onSelect(record, selected, selectedRows) {
      //如果选中，添加进去
      if (selected) {
        this.selectProductList = _.concat(this.selectProductList, record);
      } else {
        //取消选中，失效
        this.selectProductList = _.remove(this.selectProductList, function (o) {
          return o.goodsNo != record.goodsNo;
        });
      }
    },
    onSelectAll: function onSelectAll(selected, selectedRows, changeRows) {
      if (selected) {
        this.selectProductList = _.concat(this.selectProductList, changeRows);
      } else {
        this.selectProductList = [];
      }
    },
    //删除的方法
    removeConfirm: function removeConfirm(record) {
      var self = this;
      //将这一行的记录从list中移除
      if (record) {
        this.productList = _.remove(this.productList, function (o) {
          return o.goodsNo != record.goodsNo;
        });
        this.selectProductList = _.remove(this.selectProductList, function (o) {
          return o.goodsNo != record.goodsNo;
        });
      } else {
        console.log(this.selectedRowKeys, '2222222222222222');
        this.productList = _.remove(this.productList, function (o) {
          return !self.selectedRowKeys.includes(o.goodsNo);
        });
        this.selectProductList = [];
      }
      this.listTotal = this.productList.length;
    },
    // 新增/编辑保存
    saveKeyword: function saveKeyword() {
      var _this3 = this;
      this.$refs.kwruleForm.validate(/*#__PURE__*/function () {
        var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(valid) {
          var ids, params, res;
          return _regenerator().w(function (_context3) {
            while (1) switch (_context3.n) {
              case 0:
                if (!valid) {
                  _context3.n = 2;
                  break;
                }
                ids = _this3.productList.map(function (item) {
                  return item.productSpecId;
                });
                params = {
                  searchKeywords: _this3.keywordObj.keywordLangList,
                  productList: ids
                };
                _this3.listLoading = true;
                _context3.n = 1;
                return addserchKeyword(_this3.editId > 0 ? _this3.editId : 0, params);
              case 1:
                res = _context3.v;
                try {
                  if (res.data.code == 200) {
                    _this3.$message.success(_this3.$t('public.updateSuccessfully'));
                    if (!_this3.editId) {
                      _this3.$router.replace({
                        path: '/marketing/searchKeyword/searchKeywordList'
                      });
                    }
                  }
                } finally {
                  _this3.listLoading = false;
                }
              case 2:
                return _context3.a(2);
            }
          }, _callee2);
        }));
        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }());
    },
    handleChange: function handleChange(info) {
      var _this4 = this;
      var fileList = _toConsumableArray(info.fileList);
      fileList = fileList.slice(-1);
      if (fileList[0].response != undefined) {
        var newRes = fileList[0].response;
        if (newRes.code == 200) {
          //如果有导入失败的话，需要展示出导入失败的list
          if (newRes.failList.length > 0) {
            this.importVisible = true;
            this.importObj = {
              failList: newRes.failList,
              failNum: newRes.failNum,
              successList: newRes.successList,
              successNum: newRes.successNum
            };
          }
          if (newRes.successList.length > 0) {
            newRes.successList.forEach(function (item) {
              var newObj = {
                lastUpdateTime: null,
                goodsName: item.goodsName,
                goodsNo: item.goodsNo,
                productOptionName: item.specName,
                price: item.price,
                productStatus: item.productStatus,
                productStockNum: item.productStockNum,
                productSpecId: item.productSpecId
              };
              var ids = _this4.productList.map(function (item) {
                return item.productSpecId;
              });
              if (!ids.includes(item.productSpecId)) {
                _this4.productList.push(newObj);
              }
            });
            this.listTotal = this.productList.length;
            this.$message.success(this.$t("public.importsucceeded"));
          }
        } else {
          this.$message.error(this.$t("public.importfail"));
        }
      } else {}
    },
    beforeUpload: function beforeUpload(file) {
      this.files = file;
      var extension = file.name.split('.')[1] === 'xls';
      var extension2 = file.name.split('.')[1] === 'xlsx';
      var isLt5M = file.size / 1024 / 1024 < 10;
      if (!extension && !extension2) {
        this.$message.error(this.$t("public.exportpromptone"));
        return false;
      }
      if (!isLt5M) {
        this.$message.error(this.$t("public.exportprompytwo"));
        return false;
      }
    },
    /* 子组件关闭的方法 */getVisible: function getVisible(visible) {
      this.importVisible = visible;
    }
  }
};